import React, { useEffect, useState, useMemo } from 'react';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { useAuth } from '../contexts/AuthContext';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';

// 默认PayPal ClientID（生产环境）
const DEFAULT_PAYPAL_CLIENT_ID = 'AfA3baqZZItqHXDl2CK-fN2RtBouzkqgolyYn6OZALfcILPq1Kr7_J3qCnNKoV9ZL7v0T_hS4kffCpD1';

/**
 * PayPal支付集成提供者组件
 * 修复后版本 - 使用最简单的配置避免SDK加载问题
 */
const PayPalProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  const [clientId, setClientId] = useState(DEFAULT_PAYPAL_CLIENT_ID);
  const [error, setError] = useState(null);
  
  // 创建必要的PayPal选项配置
  // 必须包含currency参数，确保与创建订单时使用的货币一致
  const paypalOptions = useMemo(() => ({
    'client-id': clientId,
    currency: 'SGD' // 新加坡元
  }), [clientId]);
  
  // 从Firebase Functions获取PayPal ClientID
  useEffect(() => {
    console.log('[PayPal] 开始加载PayPal配置');
    
    const loadPayPalConfig = async () => {
      try {
        const functions = getFunctions(getApp(), 'asia-southeast1');
        const getPaypalClientIdFn = httpsCallable(functions, 'getPaypalClientId');
        
        // 设置5秒超时
        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('请求超时')), 5000)
        );
        
        const result = await Promise.race([
          getPaypalClientIdFn(),
          timeoutPromise
        ]);
        
        if (result?.data?.clientId) {
          console.log('[PayPal] 使用服务器配置的ClientID');
          setClientId(result.data.clientId);
        } else {
          console.log('[PayPal] 使用默认ClientID');
        }
      } catch (err) {
        console.warn('[PayPal] 获取配置失败，使用默认值:', err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadPayPalConfig();
    
    // 确保5秒后无论如何都结束加载状态，避免阻塞UI
    const timer = setTimeout(() => {
      if (loading) {
        console.log('[PayPal] 使用默认配置继续支付流程');
        setLoading(false);
      }
    }, 5000);
    
    return () => clearTimeout(timer);
  }, []);

  // 即使加载有问题，也尝试渲染，使用默认值
  console.log('[PayPal] 使用PayPal配置:', paypalOptions);

  return (
    <PayPalScriptProvider options={paypalOptions}>
      {children}
    </PayPalScriptProvider>
  );
};

export default PayPalProvider;